import MurphyIcon from "./MurphyIcon";
import PattyIcon from "./PattyIcon";
import StephanieIcon from "./StephanieIcon";
import ChristieIcon from "./ChristieIcon";


function People() {
    return (
        <>
            <MurphyIcon/>
            <ChristieIcon/>
            <PattyIcon/>
            <StephanieIcon/>
        </>
    )
}

export default People;